// frontend/admin-portal/src/components/settings/sections/NotificationsSettings.jsx
import React from "react";
import SettingItem from "../items/SettingItem";
import TextInput from "../items/TextInput";
import ToggleSwitch from "../items/ToggleSwitch";

export default function NotificationsSettings({ values = {}, onChange }) {
  const safeOnChange = typeof onChange === "function" ? onChange : () => {};
  return (
    <div className="fh-settings-list">
      <SettingItem label="Alert on Low Stock">
        <ToggleSwitch
          checked={values["notifications.lowStock"]}
          onChange={(v) => safeOnChange("notifications.lowStock", v)}
        />
      </SettingItem>
      <SettingItem label="Daily Email Digest">
        <ToggleSwitch
          checked={values["notifications.dailyDigest"]}
          onChange={(v) => safeOnChange("notifications.dailyDigest", v)}
        />
      </SettingItem>
      <SettingItem label="Digest Email Address">
        <TextInput
          type="email"
          value={values["notifications.digestEmail"]}
          onChange={(v) => safeOnChange("notifications.digestEmail", v)}
        />
      </SettingItem>
    </div>
  );
}
